import { ref, computed } from "vue";

const selectedLanguage = ref(localStorage.getItem("language") || "en");

const translations = {
  en: {
    title: "Welcome to the Automated Members' Availment Portal (AMAP)!",
    body: "Thank you for choosing IWC as your HMO provider! AMAP is your convenient online portal to everything you need to make the most of your IWC membership. Whether you're looking for information about your benefits, guidance on how to use your membership card, answers to FAQs, or generating your Letter of Authorization (LOAs) for consultation availments, you'll find it all here.",
    followDetails: "Through AMAP, you can:",
    containerTitle: "My Account",
    followingItems: {
      itemOne: "View your membership benefits and coverage information.",
      itemTwo: "Learn how to use your IWC card and avail of services.",
      itemThree: "Access FAQs and helpful guides.",
      itemFour: "Request consultation LOAs and teleconsultation services.",
      itemFive: "Find accredited hospitals and clinics.",
    },
    followFooter:
      "We remain committed to making your healthcare experience simple, convenient, and accessible. Say yes to good health with IWC!",
    sectionHeadertitle: "How to Make Use of Your HMO Benefits",
    sectionHeaderMessage:
      "Learn how to make the most of your HMO benefits. Access healthcare services with confidence and ease.",
    sectionItemCategory: {
      categoryOne: "Policy Details",
      categoryTwo: "Request LOA",
      subcategoryTwo: "Consultation Only",
      categoryThree: "AMAP Transaction History",
      categoryFour: "Teleconsultation",
      categoryFive: "Contact Us",
    },
  },
  ph: {
    title:
      "Maligayang pagdating sa AMAP (Automated Members' Availment Portal)!",
    body: "Maraming salamat sa pagpili sa IWC bilang inyong HMO provider! Ang AMAP ay inyong portal para sa mahahalagang impormasyon at serbisyong may kaugnayan sa inyong IWC membership. Dito, maaari ninyong makita ang inyong mga benepisyo, gabay sa paggamit ng inyong membership card, mga sagot sa madalas itanong (FAQs), at makapag-generate ng inyong Letter of Authorization (LOA) para sa consultation availments.",
    followDetails: "Sa pamamagitan ng AMAP, maaari mong:",
    containerTitle: "Impormasyon ng Account",
    followingItems: {
      itemOne:
        "Tingnan ang inyong mga benepisyo at saklaw ng inyong membership.",
      itemTwo:
        "Alamin kung paano gamitin ang inyong IWC card at mag-avail ng mga serbisyong sakop ng inyong HMO.",
      itemThree:
        "I-access ang mga madalas itanong (FAQs) at mga kapaki-pakinabang na gabay.",
      itemFour:
        "Humiling ng consultation LOA at mag-avail ng teleconsultation services.",
      itemFive: "Maghanap ng mga accredited na ospital at klinika.",
    },
    followFooter:
      "Nananatili kaming nakatuon sa pagbibigay ng simple, maginhawa, at madaling ma-access na karanasan sa pangangalagang pangkalusugan. Sabihin ang oo sa mabuting kalusugan kasama ang IWC!",
    sectionHeadertitle: "Paano Mapakinabangan ang Iyong mga Benepisyo sa HMO",
    sectionHeaderMessage:
      "Alamin kung paano lubos na mapakinabangan ang iyong mga benepisyo sa HMO.",
    sectionItemCategory: {
      categoryOne: "Impormasyon ng Benepisyo",
      categoryTwo: "Pagproseso ng LOA",
      subcategoryTwo: "Konsultasyon",
      categoryThree: "Rekord ng mga Transaksyon",
      categoryFour: "Telekonsultasyon",
      categoryFive: "Makipag-ugnayan sa Amin",
    },
  },
};

export function useLanguage() {
  const setLanguage = (lang) => {
    selectedLanguage.value = lang;
    localStorage.setItem("language", lang);
  };

  const currentText = computed(() => {
    return translations[selectedLanguage.value];
  });

  return {
    selectedLanguage,
    setLanguage,
    currentText,
  };
}
